export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-25.3936a486.png";